import axios from 'axios'

class Antifraud {
  async find (personId) {
    const path = `${process.env.VUE_APP_API_URL}/api/v2/persons/analyze/${personId}`
    const response = await axios.get(path)

    return response && response.status === 200 ? response.data : null
  }
}

export default class AntifraudApi {
  antifraud = new Antifraud()
}
